import { DEFAULT_CONFIG } from '../constants';
import { PublicApiClient } from './PublicApiClient';

// eslint-disable-next-line import/no-anonymous-default-export
const _default_1: PublicApiClient = new PublicApiClient(DEFAULT_CONFIG.publicApiRoot);

export default _default_1;
